/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * Data IDs for testing purposes of the monitoring capability.
 */
export const MONITORING_DATA_IDS = {
  breadcrumbs: 'Dashboard: Breadcrumbs',
} as const;
